'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { Box, Container, Typography, Button } from '@mui/material';
import { useRouter } from 'next/navigation';

function RedirectButton() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const from = searchParams.get('from') || '/';

  return (
    <Button
      variant="contained"
      color="primary"
      onClick={() => router.push(from)}
      sx={{ mt: 2 }}
    >
      Go Back
    </Button>
  );
}

function NotFoundContent() {
  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Box textAlign="center">
        <Typography variant="h1" component="h1" gutterBottom>
          404
        </Typography>
        <Typography variant="h4" component="h2" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          The page you are looking for does not exist or has been moved.
        </Typography>
        <Suspense fallback={<div>Loading...</div>}>
          <RedirectButton />
        </Suspense>
      </Box>
    </Container>
  );
}

export default function NotFound() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <NotFoundContent />
    </Suspense>
  );
}
